import React, { FC, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

type TextBlock = {
  type: string;
  children: { text: string }[];
};

type SectionsFullWidthMediaProps = {
  data: {
    __typename?: string;
    heading?: string;
    content?: TextBlock[];
    padding: {
      mobile_top_padding: any;
      mobile_bottom_padding: any;
      desktop_top_padding: any;
      desktop_bottom_padding: any;
    };
  };
};
type BlocksRendererProps = React.ComponentProps<typeof BlocksRenderer>;

const ComponentSectionsInlineTextBlock: FC<SectionsFullWidthMediaProps> = ({ data }) => {
  const heading = data?.heading || '';
  const content = data?.content || [];
  const [top, setTop] = useState('');
  const [bottom, setBottom] = useState('');

  useEffect(() => {
    const updatePadding = () => {
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        setTop(data.padding?.mobile_top_padding ?? '');
        setBottom(data.padding?.mobile_bottom_padding ?? '');
      } else {
        setTop(data.padding?.desktop_top_padding ?? '');
        setBottom(data.padding?.desktop_bottom_padding ?? '');
      }
    };

    updatePadding(); // Run on mount

    window.addEventListener('resize', updatePadding); // Listen on resize
    return () => window.removeEventListener('resize', updatePadding); // Clean up
  }, [data]);
  // console.log(data, 'data');
  return (
    <section
      className=""
      id={data?.__typename}
      style={{
        paddingTop: `${top}rem`,
        paddingBottom: `${bottom}rem`,
      }}
    >
      <div className="items-center">
        <div className="col-span-12 md:col-span-6 md:mt-[0] md:pt-5 text-[#E5E1D5] text-xl leading-6 md:leading-8 md:text-2xl font-light relative blocksRenderer">
          {heading && (
            <motion.h2
              className="text-base font-light text-[#B6C380] whitespace-nowrap md:absolute left-0 mb-4 md:mb-0"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, ease: 'easeOut' }}
            >
              {heading}
            </motion.h2>
          )}
          {/* {content.map((block, index) => {
            if (block.type === 'paragraph') {
              return (
                <motion.p
                  key={index}
                  className="md:indent-52"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.6, ease: 'easeOut', delay: 0.2 * index }}
                >
                  {block.children.map((child, idx) => (
                    <span key={idx}>{child.text}</span>
                  ))}
                </motion.p>
              );
            }
            return null;
          })} */}
          <div className="md:indent-52">
            <BlocksRenderer content={content as BlocksRendererProps['content']} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComponentSectionsInlineTextBlock;
